<template>
  <div>
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="swiper-container" id="mobile_swiper" 
      style="width: 100%;max-height: 670px;">
      <div class="swiper-wrapper scroll-box" style="height: 670px;">
        <router-link :to="'/mobileOfficial/'+item.game_tag" target="_blank" 
         v-for="(item,index) in bannerList" :key="index" class="swiper-slide" :style="'background-image: url('+baseAddress+item.banner_url+');'">
          <div class="banner-body">
            <img class="banner-logo" :src="baseImageAddress + 'type=small&game_tag=' + item.game_tag">
            <span class="banner-title">{{item.game_name}}</span>
            <span class="banner-summary">{{item.game_summary}}</span>
            <div class="banner-enter">
              <span>查询详情<i></i></span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="banner-small">
      <div class="banner-small-item" :class="mobileSwiper.activeIndex == index ? 'banner-active' : ''"
         v-for="(item,index) in bannerList" :key="index" @click="selectAd(index);">
        <div></div>
        <img :src="baseAddress+item.banner_other_url" v-bind:title="item.banner_summary">
      </div>
    </div>
    <div class="theme-content-body">
      <div class="recommend-game-left">
        <div class="common-item-top">
          <span class="common-top-icon"></span>
          <span class="common-top-title">推荐游戏</span>
          <span class="common-top-h1">Recommended games</span>
          <a class="common-more" style="margin-left: 40%;" @click="enterGameCenter"></a>
        </div>
        <div class="recommend-item-body">
          <div class="mobile-game-item" v-for="(item,index) in recommendList" :key="index"
            :class="index%3 == 2 ? 'mr-0':''">
            <a class="mobile-game-hide" :href="'/mobileOfficial/'+item.ah_tag" title="官网" target="_blank">
              <img :src="baseQrAddress+'type=qr_mobile&game_tag='+item.ah_tag" class="mobile-game-qr">
              <p class="mobile-game-title">游戏类型:{{item.type_name}}</p>
              <p class="mobile-game-count">
                <span>玩家评分:</span>
                <i></i>
                <i></i>
                <i></i>
                <i></i>
                <i></i>
              </p>
              <p class="mobile-game-hint">手机扫码下载</p>
            </a>
            <img :src="baseImageAddress+'type=game&game_tag='+item.ah_tag " class="mobile-game-img"/>
            <div class="mobile-game-opeartor">
              <div class="mobile-game-text-body">
                <span>{{item.ah_name}}</span>
                <span>{{item.ah_type_name}}</span>
              </div>
              <a :href="'/mobileOfficial/'+item.ah_tag" title="官网" 
              class="mobile-game-operate mobile-game-official" target="_blank" style="right:90px;">
                <i></i>官网
              </a>
              <a :href="baseAddress+'download/'+item.ah_tag+'?type=1'" title="立即下载" 
              class="mobile-game-operate mobile-game-download" target="_blank">
                <i></i>
                立即下载
              </a>
            </div>
          </div>   
        </div>
      </div>
      <div class="recommend-game-right">
        <div class="common-item-top" style="width: 100%;">
          <span class="common-top-icon"></span>
          <span class="common-top-title">开服表</span>
          <span class="common-top-h1">Dress chart</span>
        </div>
        <div class="server-body" style="height: 998px;">
          <div class="server-item" v-for="(item,index) in themeServerList" :key="index">
            <a :href="'/mobileOfficial/'+item.game_tag" target="_blank" class="server-item-img">
              <img :src="baseImageAddress+'type=small&game_tag='+item.game_tag">
            </a>
            <div class="server-item-content">
              <span class="server-title">{{item.game_name}}</span>
              <span class="server-label">{{item.game_area_name}}</span>
              <span class="server-time">{{new Date(item.game_area_time).Format("MM-dd hh:mm")}}</span>
            </div>
            <a class="server-download" :href="'/mobileOfficial/'+item.game_tag" target="_blank">进入</a>
          </div>     
        </div>
        <div class="common-page-rank-body" style="margin-top: -32px;">
          <ul class="common-page-rank-ul">
            <li class="common-page-rank-li" :class="themePageCurrent === index
                  ? 'common-page-rank-li-active' : ''" v-for="(item, index) in themePageIndicate"
              :key="index" @click="selectThemePage(index)" @mouseenter="selectThemePage(index)"></li>
          </ul>
        </div>  
      </div>
    </div>
    <div class="common-content-body theme-gift-body" style="margin-bottom: 34px;">
      <div class="common-item-top">
        <span class="common-top-icon"></span>
        <span class="common-top-title">推荐礼包</span>
        <span class="common-top-h1">Recommended gift bag</span>
        <a class="common-more" style="margin-left: 55.5%;" @click="enterGift"></a>
      </div>
      <div class="gift-item" :class="index%4 == 3 ? 'mr-0':''" v-for="(item,index) in giftList" :key="index">
        <img class="gift-game-img" :src="baseImageAddress+'type=small&game_tag='+item.game_tag"
          @click="enterGiftDetails(item.game_gid,item.gift_id)">
        <div class="gift-item-content">
          <span class="gift-title" v-bind:title="item.gift_name">{{item.gift_name}}</span>
          <p class="gift-p">
            <span class="gift-item-count">剩余：<i>{{item.gift_max-item.gift_count}}个</i></span>
            <span class="gift-item-param" v-if="item.gift_type == 1">{{item.gift_param}}积分</span>
            <span class="gift-item-param" v-if="item.gift_type == 2">{{item.gift_param}}平台币</span>
            <span class="gift-item-param" v-if="item.gift_type == 3">
              <img :src="vipList[item.gift_param].vsrc" :class="'vip-level-'+item.gift_param"></img>
            </span>
            <span class="gift-item-param" v-if="item.gift_type == 4">
              <img :src="vipList[0].vsrc" class="vip-level-0"></img>
            </span>
          </p>
          <a class="gift-item-receive" @click="enterGiftDetails(item.game_gid,item.gift_id)">领取</a>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
      @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
      @changeLoginState="changeLoginState"></SuspendMember>
  </div>
</template>
<script>
  import Footer from "../../components/common/Footer";
  import Header from "../../components/common/Header";
  import SuspendSide from "../../components/SuspendSide";
  import SuspendMember from "../../components/SuspendMember";
  import Swiper from 'swiper'
  import "swiper/css/swiper.css"
  export default {
    name: "MobileGame",
    metaInfo(){
      return {
        title:"手游中心_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    computed:{
      themeServerList:{
        set(value){
          this.$store.state.mobileGame.themeServerList = value;
        },
        get(){
          return this.$store.state.mobileGame.themeServerList;
        }
      },
      tempServerList:{
        set(value){
          this.$store.state.mobileGame.tempServerList = value;
        },
        get(){
          return this.$store.state.mobileGame.tempServerList;
        }
      },
      bannerList(){
        return this.$store.state.mobileGame.bannerList;
      },
      giftList(){
        return this.$store.state.mobileGame.giftList;
      },
      recommendList(){
        return this.$store.state.mobileGame.recommendList;
      },
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      },
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      baseQrAddress(){
        return this.$store.state.constant.baseQrAddress;
      },
      GameTransfer(){
        return this.$store.state.constant.GameTransfer;
      },
      vipList(){
        return this.$store.state.constant.vipList;
      }
    },
    asyncData({store,route}){ 
        return store.dispatch('initMobileGame',{store:store});
    },
    data(){
      return{
        mobileSwiper:{},
        dataTotalPage:5,
        themePageCurrent: 0,
        themePageIndicate: [],
        bannerIndex:0,
        mobileSwiperOption:{
          autoplay:{
            delay:3000,
            disableOnInteraction:false
          },
          slidesPerView: 1,
          freeMode: true,
          observe:true,
          observeParents:true,     
        },
        suspendState:false,
        suspendType:0,
        loginState:false,
      }
    },
    components: { Footer, Header, SuspendSide,SuspendMember},
    watch:{
      bannerList : function(){
        this.$nextTick(function(){
          this.initMobileSwiper();
        })
      },
    },
    mounted(){
      this.themePager();
    },
    methods:{
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      selectAd(index){
        this.mobileSwiper.slideTo(index,1000,false);
        this.mobileSwiper.autoplay.start();
      },
      enterGiftDetails(gid,lid){
        window.open(this.$router.resolve({name:"giftDetails",query: {lid:lid,gid:gid}}).href,"_blank");
      },
      enterGift(){
        window.open(this.$router.resolve({name:"gift"}).href,"_blank");
      },
      enterGameCenter(){
        window.open(this.$router.resolve({name:"gameCenter",query:{type:2}}).href,"_blank");
      },
      getThemeMobileServer() {
        this.$http.get('/query_web_game_area?type=2&state=0&count=55&row=11', {
          params: this.themeMobileServerBean
        }).then(res=>{
          if (res.data.code==2000) {
            this.themeServerList = res.data.data.slice(0,11);
            this.tempServerList = res.data.data;
            this.themePager();
          }else{
            this.themePageIndicate = [];
          }
        });
      },
      initMobileSwiper(){
        this.mobileSwiper = null;
        this.mobileSwiper = new Swiper("#mobile_swiper",this.mobileSwiperOption);
      },
      selectThemePage(value) {
        this.themePageCurrent = value;
        this.themeServerList = this.tempServerList.slice(value*11,(value+1)*11);
      },

      themePager(){
        this.themePageIndicate = [];
        for (let index = 0; index < this.dataTotalPage; index++) {
          this.themePageIndicate.push({"id":index,"title":index})
        }
      },
    }
  };
</script>
<style src="@/assets/css/game_theme.css" scoped></style>
